import React, { useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Container,Button} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { Remove} from '@mui/icons-material';


const QuestionsDialog = ({visible,setVisible,data,handleDelete,deleting})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch()
    // const [deleting,setDeleting] = useState(false)

	const onOpen = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
return <Typography  style={{fontSize:13,fontWeight:400,color:"#fff"}}> {displayText} </Typography>
}


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<MenuIcon/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Questions
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{width:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
			 {
				data?.length == 0 && (
					<Box>
						<Typography m={1} style={{fontSize:15,fontWeight:400,color:"gold"}}>
							Questions could not be found
						</Typography>
					</Box>
				)
			 }
			{
				data?.map((item,index)=>{
					return(
						<Box sx={{ display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center"}} mt={2} key={index}>
                            <Box textAlign="left" >
								<Typography style={{fontSize:11,fontWeight:400,color:"gold",fontFamily:"dinofans"}}>
									{index+1}. {item?.type === "Simple" ? "Input"  : item?.type === "One" ? "One Choice"  : (item?.type === "Image" || item?.type === "Files") ? "Upload" : item?.type} question
                                </Typography>
								<DescriptionText text={` # ${item?.content}`} limit={30}/>								
                            </Box>
                            <IconButton onClick={async(e)=>{
                                e?.preventDefault()
                                handleDelete(item)
                            }}>
                                {deleting ?
                                    <Typography sx={{fontSize:10,color:"red"}}>
                                        Deleting
                                    </Typography>
                                    :
                                    <Remove fontSize="small" sx={{color:"red"}}/>
                                }
                            </IconButton>
						</Box>
					)
				})
			}
		</DialogContent>
	</Dialog>
	)
}

export default QuestionsDialog;